"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4281],{

/***/ 44281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SearchDirectoryController": function() { return /* binding */ SearchDirectoryController; },
  "default": function() { return /* binding */ searchDirectory_SearchDirectoryController; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/pages/404.tsx
var _404 = __webpack_require__(56169);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/helpers/searchDirectoryTypeFromSearchResults.ts

/**
 * Determines the search directory template type based on the search results.
 *
 * @param searchResults - The search results object containing arrays of different result types
 * @returns The appropriate search directory template type based on the composition of search results,
 *          or null if no matching pattern is found
 *
 * The function evaluates the following scenarios:
 * - Hybrid: Both caregiver and provider results exist
 * - Caregiver: Only caregiver results exist
 * - SMB: Only provider results exist
 * - Job: Job or archived job results exist
 */ var searchDirectoryTypeFromSearchResults = function(searchResults) {
    var caregiverSearchResults = searchResults.caregiverSearchResults, jobSearchResults = searchResults.jobSearchResults, providerSearchResults = searchResults.providerSearchResults, archivedJobSearchResults = searchResults.archivedJobSearchResults;
    // Hybrid results
    if (caregiverSearchResults.length > 0 && providerSearchResults.length > 0) {
        return constants/* SEARCH_DIRECTORY_TEMPLATE_TYPE.HYBRID */.iK.HYBRID;
    }
    // Caregiver results
    if (caregiverSearchResults.length > 0 && providerSearchResults.length === 0) {
        return constants/* SEARCH_DIRECTORY_TEMPLATE_TYPE.CAREGIVER */.iK.CAREGIVER;
    }
    // SMB Results
    if (providerSearchResults.length > 0 && caregiverSearchResults.length === 0) {
        return constants/* SEARCH_DIRECTORY_TEMPLATE_TYPE.SMB */.iK.SMB;
    }
    // Job and Archived Job Results
    if (jobSearchResults.length > 0 || archivedJobSearchResults.length > 0) {
        return constants/* SEARCH_DIRECTORY_TEMPLATE_TYPE.JOB */.iK.JOB;
    }
    return null; // Fallback to null if no results found
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/SeoGlobalNavbar.tsx + 10 modules
var SeoGlobalNavbar = __webpack_require__(28528);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/components/hooks/useLDClientFlags.tsx
var useLDClientFlags = __webpack_require__(32778);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(387);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24ResponseTime.js
var Icon24ResponseTime = __webpack_require__(54173);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24CalendarAndAvailability.js
var Icon24CalendarAndAvailability = __webpack_require__(20382);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24Search.js
var Icon24Search = __webpack_require__(49801);
// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
;// CONCATENATED MODULE: ./src/types/WhenCareModal.ts
var MODAL_VARIANT_TYPE = {
    DEFAULT: "default",
    CHILDCARE_LOCATION: "childCareLocation",
    PET_CARE: "petCare",
    SENIOR_CARE: "seniorCare"
};

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/modals/helpers/getWhenCareModalVariant.ts


var getWhenCareModalVariant = function(serviceIdForMember) {
    if (serviceIdForMember === constants/* ServiceIdForMember.CHILD_CARE_LOCATION */.u2.CHILD_CARE_LOCATION) {
        return MODAL_VARIANT_TYPE.CHILDCARE_LOCATION;
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.PET_CARE */.u2.PET_CARE || serviceIdForMember === constants/* ServiceIdForMember.PET_DAY_CARE_LOCATION */.u2.PET_DAY_CARE_LOCATION || serviceIdForMember === constants/* ServiceIdForMember.PET_SITTING_WALKING */.u2.PET_SITTING_WALKING) {
        return MODAL_VARIANT_TYPE.PET_CARE;
    }
    if (serviceIdForMember === constants/* ServiceIdForMember.SENIOR_CARE */.u2.SENIOR_CARE || serviceIdForMember === constants/* ServiceIdForMember.HOME_CARE_LOCATION */.u2.HOME_CARE_LOCATION) {
        return MODAL_VARIANT_TYPE.SENIOR_CARE;
    }
    return MODAL_VARIANT_TYPE.DEFAULT;
};

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/modals/WhenCareModal.tsx











var WhenCareModal = function(param) {
    var enrollmentURL = param.enrollmentURL, modalTitle = param.modalTitle, pageType = param.pageType, serviceIdForMember = param.serviceIdForMember;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNameSingularLowerCase = ref1.segmentNameSingularLowerCase, searchingFor = ref1.searchingFor;
    var daycareDirectoryFirstFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id);
    var isJobSegment = Boolean(searchingFor && searchingFor in constants/* JOB_SEARCHING_FOR */.kK);
    var MODAL_VARIANTS = {
        default: {
            title: isJobSegment ? "When do you want a job?" : modalTitle,
            options: [
                {
                    label: "Right now",
                    intent: "rightNow",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24ResponseTime/* default */.Z, {})
                },
                {
                    label: "Within a month",
                    intent: "withInMonth",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24CalendarAndAvailability/* default */.Z, {})
                },
                {
                    label: "Just browsing",
                    intent: "justBrowsing",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24Search/* default */.Z, {})
                }, 
            ]
        },
        childCareLocation: {
            title: "How old is your child?",
            subtitle: "Let's find a ".concat(segmentNameSingularLowerCase, " for you!"),
            options: [
                {
                    label: "0 – 12 months"
                },
                {
                    label: "1 – 4 years"
                },
                {
                    label: "4 – 6 years"
                },
                {
                    label: "6+ years"
                }, 
            ]
        },
        petCare: {
            title: "How many pets need care?",
            subtitle: "Tell us about your needs!",
            options: [
                {
                    label: "1"
                },
                {
                    label: "2"
                },
                {
                    label: "3+"
                }
            ]
        },
        seniorCare: {
            title: "Who needs care?",
            options: [
                {
                    label: "A loved one"
                },
                {
                    label: "Myself"
                }
            ]
        }
    };
    (0,react.useEffect)(function() {
        var doesCookieExist = function(cookieName) {
            return !document.cookie.split(";").some(function(cookie) {
                return cookie.trim().startsWith(cookieName);
            });
        };
        if (doesCookieExist("crcmWhenCareModalShown=")) {
            setTimeout(function() {
                setOpen(true);
                var cookieDate = new Date();
                cookieDate.setDate(cookieDate.getDate() + 90);
                document.cookie = "crcmWhenCareModalShown=true; expires=".concat(cookieDate.toUTCString(), "; path=/");
            }, 3000);
        }
    }, []);
    var handleModalButton = function(e) {
        e.preventDefault();
        var amplitudeData = {
            asset_type: "Lightbox",
            CTA: e.currentTarget.textContent,
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.monetateAssetClicked */.Sj.monetateAssetClicked, amplitudeData);
        if (daycareDirectoryFirstFlag && daycareDirectoryFirstFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.DAYCARE_DIRECTORY_FIRST_FLOW.id */.WV.DAYCARE_DIRECTORY_FIRST_FLOW.id,
                test_variant: daycareDirectoryFirstFlag.variationIndex,
                service_id_for_member: serviceIdForMember,
                page_template: pageType
            });
        }
        globalThis.location.href = e.currentTarget.href;
    };
    var handleCloseModal = function() {
        setOpen(false);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.monetateAssetClicked */.Sj.monetateAssetClicked, {
            asset_type: "Lightbox",
            CTA: "X",
            messagingContent: "Join now",
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION
        });
    };
    var ModalVariant = getWhenCareModalVariant(serviceIdForMember);
    var currentVariant = MODAL_VARIANTS[ModalVariant];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        open: open,
        maxWidth: "xl",
        variant: isSmallViewport ? "default" : "dynamic",
        onClose: handleCloseModal,
        children: [
            (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                mb: 1,
                variant: "serifHeadline3",
                textAlign: "center",
                children: currentVariant.subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "display4",
                component: "h3",
                textAlign: "center",
                children: currentVariant.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                mt: 4,
                mx: "auto",
                maxWidth: "256px",
                spacing: 2,
                children: currentVariant.options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        rel: "nofollow",
                        component: "a",
                        size: "large",
                        variant: "outlined",
                        fullWidth: true,
                        startIcon: option.icon,
                        href: "".concat(enrollmentURL).concat(option.intent ? "&intent=".concat(option.intent) : ""),
                        onClick: handleModalButton,
                        children: option.label
                    }, option.label);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/PageMeta/getPageTitle.ts

/**
 * Generates a title for a page based on provided properties.
 *
 * If the current page is 1, returns the default title.
 * Otherwise, creates a title with a "Page X - Top " prefix followed by the segment name.
 * For local page types, the title includes city and state information.
 *
 * @param {Object} params - The parameters for generating the page title
 * @param {string} params.defaultTitle - The default title to use for the first page
 * @param {number} params.curPage - The current page number
 * @param {string} params.segmentNamePlural - The plural name of the segment (e.g., "Doctors", "Restaurants")
 * @param {string|null} params.city - The city name, or null if not applicable
 * @param {string|null} params.state - The state name, or null if not applicable
 * @param {SEOSegmentationPageType|null} params.pageType - The type of page, or null if not applicable
 * @returns {string} The generated page title
 */ var getPageTitle = function(param) {
    var defaultTitle = param.defaultTitle, curPage = param.curPage, segmentNamePlural = param.segmentNamePlural, city = param.city, state = param.state, pageType = param.pageType;
    if (curPage === 1) return defaultTitle;
    var prefix = "Page ".concat(curPage, " - Top ");
    if (city === null || state === null || pageType === null) {
        return "".concat(prefix).concat(segmentNamePlural);
    }
    return pageType === globalTypes/* SEOSegmentationPageType.LOCAL */.a6.LOCAL ? "".concat(prefix).concat(segmentNamePlural, " in ").concat(city, ", ").concat(state) : "".concat(prefix).concat(segmentNamePlural);
};

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/PageMeta/PageMeta.tsx






var ref = config_default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var PageMeta = function(param) {
    var hrefLangLinks = param.hrefLangLinks, title = param.title, canonicalUrl = param.canonicalUrl, metaDescriptions = param.metaDescriptions, metaKeywords = param.metaKeywords, _paginationPageCount = param.paginationPageCount, paginationPageCount = _paginationPageCount === void 0 ? 1 : _paginationPageCount, _paginationCurrentPage = param.paginationCurrentPage, paginationCurrentPage = _paginationCurrentPage === void 0 ? 1 : _paginationCurrentPage;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNamePlural = ref.segmentNamePlural, _pageType = ref.pageType, pageType = _pageType === void 0 ? null : _pageType, _city = ref.city, city = _city === void 0 ? null : _city, _state = ref.state, state = _state === void 0 ? null : _state;
    var logoPath = "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg?v=2");
    var isNotFirstPage = paginationCurrentPage > 1;
    var isLocalPage = pageType === globalTypes/* SEOSegmentationPageType.LOCAL */.a6.LOCAL;
    var isFirstPage = paginationCurrentPage === 1;
    var shouldNoIndexPage = isNotFirstPage && isLocalPage;
    var canonicalPageUrl = isFirstPage ? canonicalUrl : "".concat(canonicalUrl, "-page").concat(paginationCurrentPage);
    var pageTitle = getPageTitle({
        defaultTitle: title,
        curPage: paginationCurrentPage,
        segmentNamePlural: segmentNamePlural,
        city: city,
        state: state,
        pageType: pageType
    });
    var nextLink = null;
    var prevLink = null;
    // Set next link if there's a next page
    if (paginationCurrentPage < paginationPageCount) {
        var nextPageNumber = paginationCurrentPage + 1;
        var pageUrlSuffix = isFirstPage ? "-page2" : "-page".concat(nextPageNumber);
        nextLink = canonicalUrl + pageUrlSuffix;
    }
    // Set previous link if we're not on the first page
    if (paginationPageCount > 1) {
        prevLink = paginationCurrentPage === 2 ? canonicalUrl : "".concat(canonicalUrl, "-page").concat(paginationCurrentPage - 1);
    }
    var cleanHrefLangLinks = hrefLangLinks === null || hrefLangLinks === void 0 ? void 0 : hrefLangLinks.filter(function(link) {
        return link !== null && link !== undefined;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            cleanHrefLangLinks === null || cleanHrefLangLinks === void 0 ? void 0 : cleanHrefLangLinks.map(function(param) {
                var languageCode = param.languageCode, countryCode = param.countryCode, url = param.url;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    href: url,
                    hrefLang: "".concat(languageCode, "-").concat(countryCode)
                }, url);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: metaDescriptions
            }),
            metaKeywords && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: metaKeywords
            }),
            shouldNoIndexPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex, follow"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalPageUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "verify-v1",
                content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY="
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: pageTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: logoPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: metaDescriptions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "Care.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "image/jpeg",
                property: "og:image:type"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "1080",
                property: "og:image:width"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "1080",
                property: "og:image:height"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "fb:page_id",
                content: "6030284861"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        logo: logoPath,
                        name: "Care.com",
                        sameAs: [
                            "https://www.facebook.com/caredotcom/",
                            "https://twitter.com/CareDotCom",
                            "https://www.instagram.com/careorg/",
                            "https://www.linkedin.com/company/care-com", 
                        ],
                        url: "https://www.care.com"
                    })
                }
            }),
            nextLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "next",
                href: nextLink
            }),
            prevLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "prev",
                href: prevLink
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/helpers/trackPageViewedEvent.ts




var trackPageViewedEvent = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var pageTitle, serviceIdForMember, amplitudeTestName, searchingFor, pageType, seoSegmentationSearchResults, isJobSegment, seoPageType, amplitudeDataForPageViewed, amplitudeDataForTestExposure;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pageTitle = param.pageTitle, serviceIdForMember = param.serviceIdForMember, amplitudeTestName = param.amplitudeTestName, searchingFor = param.searchingFor, pageType = param.pageType, seoSegmentationSearchResults = param.seoSegmentationSearchResults;
                    isJobSegment = searchingFor in constants/* JOB_SEARCHING_FOR */.kK;
                    seoPageType = function() {
                        if (isJobSegment) {
                            return "Provider SEO page";
                        }
                        if (seoSegmentationSearchResults.providerSearchResults.length > 0) {
                            return "SMB SEO page";
                        }
                        return "Seeker SEO page";
                    };
                    amplitudeDataForPageViewed = {
                        seo_page_title: pageTitle,
                        seo_page_type: seoPageType(),
                        service_id_for_member: serviceIdForMember,
                        page_template: pageType
                    };
                    amplitudeDataForTestExposure = {
                        test_name: amplitudeTestName,
                        test_variant: "1",
                        service_id_for_member: serviceIdForMember,
                        page_template: pageType
                    };
                    if (!amplitudeTestName) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, amplitudeDataForTestExposure)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoPageViewed */.Sj.seoPageViewed, amplitudeDataForPageViewed)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function trackPageViewedEvent(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/SearchDirectoryLayout.tsx










var SearchDirectoryLayout = function(param) {
    var children = param.children, enrollmentURL = param.enrollmentURL, deviceChar = param.deviceChar, pageData = param.pageData, testName = param.testName;
    var seoSegmentationSearchResults = pageData.seoSegmentationSearchResults, seoSegmentationDetails = pageData.seoSegmentationDetails, seoNavigationLinkSection = pageData.seoNavigationLinkSection;
    var pageType = seoSegmentationDetails.pageType, serviceIdForMember = seoSegmentationDetails.serviceIdForMember, conversionHeader = seoSegmentationDetails.conversionHeader, _seoPageMetadata = seoSegmentationDetails.seoPageMetadata, canonicalURL = _seoPageMetadata.canonicalURL, metaDescriptions = _seoPageMetadata.metaDescriptions, title = _seoPageMetadata.title, hrefLangLinks = _seoPageMetadata.hrefLangLinks, metaKeywords = _seoPageMetadata.metaKeywords, seoPageId = _seoPageMetadata.seoPageId;
    var _pagination = seoSegmentationSearchResults.pagination, currentPage = _pagination.currentPage, numberOfPages = _pagination.numberOfPages, seoBackEndTests = seoSegmentationSearchResults.tests;
    var ref = (0,useLDClientFlags/* useLDClientFlags */.y)(), reviewsAboveSearchResultsFlag = ref.SEO_3708_REVIEWS_SECTION_SEO, salcRobustProviderCardFlag = ref.SEO_3169_SALC_ROBUST_PROVIDER_CARDS, aboveTheFoldTestJobsFlag = ref.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS, growthEnrollmentSeekerAdultCareRolloutFlag = ref.GROWTH_ENROLLMENT_SEEKER_ADULT_CARE_ROLLOUT;
    (0,react.useEffect)(function() {
        var pageProperties = {
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION,
            seo_page_id: parseInt(seoPageId, 10),
            service_id_for_member: serviceIdForMember,
            slots: constants/* TealiumSlot.VISITOR */.vm.VISITOR
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
    }, [
        deviceChar,
        seoPageId,
        serviceIdForMember
    ]);
    (0,react.useEffect)(function() {
        trackPageViewedEvent({
            pageTitle: seoSegmentationDetails.headline,
            serviceIdForMember: serviceIdForMember,
            amplitudeTestName: testName,
            searchingFor: seoSegmentationDetails.searchingFor,
            pageType: pageType,
            seoSegmentationSearchResults: seoSegmentationSearchResults
        });
        if (seoBackEndTests) {
            seoBackEndTests.forEach(function(seoBETest) {
                return (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                    test_name: seoBETest.testName,
                    test_variant: seoBETest.testVariant,
                    service_id_for_member: seoSegmentationDetails.serviceIdForMember,
                    page_template: pageType
                });
            });
        }
        if (salcRobustProviderCardFlag && salcRobustProviderCardFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3169_SALC_ROBUST_PROVIDER_CARDS.id */.WV.SEO_3169_SALC_ROBUST_PROVIDER_CARDS.id,
                test_variant: salcRobustProviderCardFlag.variationIndex,
                service_id_for_member: seoSegmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
        if (aboveTheFoldTestJobsFlag && aboveTheFoldTestJobsFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id */.WV.SEO_3217_ABOVE_THE_FOLD_CONVERSION_TEST_PROVIDERS.id,
                test_variant: aboveTheFoldTestJobsFlag.variationIndex,
                service_id_for_member: seoSegmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
        if (reviewsAboveSearchResultsFlag && reviewsAboveSearchResultsFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.SEO_3708_REVIEWS_SECTION_SEO.id */.WV.SEO_3708_REVIEWS_SECTION_SEO.id,
                test_variant: reviewsAboveSearchResultsFlag.variationIndex,
                service_id_for_member: seoSegmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
        if (growthEnrollmentSeekerAdultCareRolloutFlag && growthEnrollmentSeekerAdultCareRolloutFlag.reason.kind === constants/* LaunchDarklyEvaluationReasons.RULE_MATCH */.Dn.RULE_MATCH) {
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.testExposure */.Sj.testExposure, {
                test_name: constants/* UI_FEATURE_FLAGS.GROWTH_ENROLLMENT_SEEKER_ADULT_CARE_ROLLOUT.id */.WV.GROWTH_ENROLLMENT_SEEKER_ADULT_CARE_ROLLOUT.id,
                test_variant: growthEnrollmentSeekerAdultCareRolloutFlag.variationIndex,
                service_id_for_member: seoSegmentationDetails.serviceIdForMember,
                page_template: pageType
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta, {
                title: title,
                canonicalUrl: canonicalURL,
                metaDescriptions: metaDescriptions,
                metaKeywords: metaKeywords,
                hrefLangLinks: hrefLangLinks,
                paginationPageCount: numberOfPages,
                paginationCurrentPage: currentPage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* SeoGlobalNavbar */.L, {
                seoNavigationLinkSection: seoNavigationLinkSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhenCareModal, {
                enrollmentURL: enrollmentURL,
                pageType: pageType,
                serviceIdForMember: serviceIdForMember,
                modalTitle: conversionHeader
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/feature/searchDirectory/SearchDirectoryController.tsx







var CaregiverSearchDirectory = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(925), __webpack_require__.e(6877), __webpack_require__.e(1903), __webpack_require__.e(3816), __webpack_require__.e(6492), __webpack_require__.e(5910), __webpack_require__.e(3829), __webpack_require__.e(7212), __webpack_require__.e(3255), __webpack_require__.e(5628), __webpack_require__.e(2104), __webpack_require__.e(1796), __webpack_require__.e(838), __webpack_require__.e(1958), __webpack_require__.e(734), __webpack_require__.e(9162), __webpack_require__.e(7349), __webpack_require__.e(9133), __webpack_require__.e(1878), __webpack_require__.e(4774), __webpack_require__.e(6983)]).then(__webpack_require__.bind(__webpack_require__, 76983));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76983)
            ];
        }
    }
});
var JobSearchDirectory = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(925), __webpack_require__.e(365), __webpack_require__.e(6877), __webpack_require__.e(1903), __webpack_require__.e(3816), __webpack_require__.e(6492), __webpack_require__.e(5910), __webpack_require__.e(9975), __webpack_require__.e(3255), __webpack_require__.e(9644), __webpack_require__.e(7533), __webpack_require__.e(8782), __webpack_require__.e(734), __webpack_require__.e(2479), __webpack_require__.e(7349), __webpack_require__.e(9133), __webpack_require__.e(3016)]).then(__webpack_require__.bind(__webpack_require__, 33016));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33016)
            ];
        }
    }
});
var HybridSearchDirectory = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(925), __webpack_require__.e(6877), __webpack_require__.e(1903), __webpack_require__.e(3816), __webpack_require__.e(6492), __webpack_require__.e(5910), __webpack_require__.e(3829), __webpack_require__.e(7212), __webpack_require__.e(3255), __webpack_require__.e(5628), __webpack_require__.e(2104), __webpack_require__.e(1796), __webpack_require__.e(838), __webpack_require__.e(1958), __webpack_require__.e(734), __webpack_require__.e(9162), __webpack_require__.e(7349), __webpack_require__.e(9133), __webpack_require__.e(1878), __webpack_require__.e(4774), __webpack_require__.e(5430)]).then(__webpack_require__.bind(__webpack_require__, 55430));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55430)
            ];
        }
    }
});
var SMBSearchDirectory = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(925), __webpack_require__.e(6877), __webpack_require__.e(1903), __webpack_require__.e(3816), __webpack_require__.e(6492), __webpack_require__.e(5910), __webpack_require__.e(3829), __webpack_require__.e(3255), __webpack_require__.e(5628), __webpack_require__.e(2104), __webpack_require__.e(838), __webpack_require__.e(1943), __webpack_require__.e(7349), __webpack_require__.e(9133), __webpack_require__.e(1878), __webpack_require__.e(8899)]).then(__webpack_require__.bind(__webpack_require__, 38899));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38899)
            ];
        }
    }
});
var SearchDirectoryController = function(props) {
    var pageData = props.pageData, enrollmentURL = props.enrollmentURL, deviceChar = props.deviceChar, testName = props.testName;
    var searchResults = pageData.seoSegmentationSearchResults;
    var renderDirectoryContent = function() {
        var searchDirectoryType = searchDirectoryTypeFromSearchResults(searchResults);
        switch(searchDirectoryType){
            case constants/* SEARCH_DIRECTORY_TEMPLATE_TYPE.CAREGIVER */.iK.CAREGIVER:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CaregiverSearchDirectory, (0,_object_spread/* default */.Z)({}, props));
            case constants/* SEARCH_DIRECTORY_TEMPLATE_TYPE.SMB */.iK.SMB:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SMBSearchDirectory, (0,_object_spread/* default */.Z)({}, props));
            case constants/* SEARCH_DIRECTORY_TEMPLATE_TYPE.HYBRID */.iK.HYBRID:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HybridSearchDirectory, (0,_object_spread/* default */.Z)({}, props));
            case constants/* SEARCH_DIRECTORY_TEMPLATE_TYPE.JOB */.iK.JOB:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobSearchDirectory, (0,_object_spread/* default */.Z)({}, props));
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404/* default */.Z, {
                    showGlobalNav: false
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDirectoryLayout, {
        pageData: pageData,
        testName: testName,
        enrollmentURL: enrollmentURL,
        deviceChar: deviceChar,
        children: renderDirectoryContent()
    });
};
/* harmony default export */ var searchDirectory_SearchDirectoryController = (SearchDirectoryController);


/***/ }),

/***/ 32778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useLDClientFlags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42660);
/* harmony import */ var _components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63880);



var useLDClientFlags = function() {
    var featureFlags = (0,_components_contexts_FeatureFlagsContext__WEBPACK_IMPORTED_MODULE_1__/* .useFeatureFlags */ .g)();
    var activeFlags = {};
    return Object.entries(_constants__WEBPACK_IMPORTED_MODULE_0__/* .UI_FEATURE_FLAGS */ .WV).reduce(function(acc, flag) {
        var ref;
        var _flag = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(flag, 2), flagName = _flag[0], flagDetails = _flag[1];
        var currentFlag = featureFlags === null || featureFlags === void 0 ? void 0 : (ref = featureFlags.flags) === null || ref === void 0 ? void 0 : ref[flagDetails.id];
        acc[flagName] = currentFlag;
        return acc;
    }, activeFlags);
};


/***/ }),

/***/ 56169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Custom404; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _care_navigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79976);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86886);
/* harmony import */ var _care_react_pages__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56975);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56721);
/* harmony import */ var _components_common_SeoGlobalNavbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28528);






function Custom404(param) {
    var _showGlobalNav = param.showGlobalNav, showGlobalNav = _showGlobalNav === void 0 ? true : _showGlobalNav;
    var isEmbraceTheme = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isEmbraceTheme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        container: true,
        children: [
            showGlobalNav && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_SeoGlobalNavbar__WEBPACK_IMPORTED_MODULE_1__/* .SeoGlobalNavbar */ .L, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                py: 3,
                px: 9,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_pages__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        prev: "/"
                    }),
                    ";"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_navigation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: isEmbraceTheme ? "inverse" : "default"
                })
            })
        ]
    });
}


/***/ })

}]);